import { toast } from "react-toastify";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { isSuccessHTTPCode } from "@src/utils/utils";
import { getAccessToken } from "@shared/api/getAccessToken";
import { API } from "../authSlice";

export const sendSmsCode = createAsyncThunk<any, any, { rejectValue: { message: string } }>(
    "auth/sendSmsCode",
    async (payload: any, thunkAPI) => {
        const TOKEN = getAccessToken();
        try {
            const response = await fetch(`${API}/v1/verification/phone/change`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-Auth-token": TOKEN
                },
                body: JSON.stringify(payload)
            });

            let data = await response.json();

            if (isSuccessHTTPCode(response.status)) {
                return data;
            } else {
                toast.error(`Ошибка на сервере: ${data.message}, код ошибки: ${response.status}`, {
                    autoClose: 5000
                });
                throw new Error(data.message);
            }
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ message: error.message });
        }
    }
);